import { gql } from "@apollo/client";

/**
 * Current structure of a system's subtree, used to pre-validate the system-type
 * picker (IBM-462): direct pressure lines come from nodeRules (ACL-free, exactly
 * what the backend enforces), the subtree asset total from assetCount.
 */
export const SystemStructureCounts = gql`
    query SystemStructureCounts($id: ID!) {
        system(id: $id) {
            id
            installedBaseNode {
                id
                assetCount
                nodeRules {
                    childRules {
                        nodeTypeKey
                        currentNodeCount
                        limits {
                            min
                            max
                        }
                    }
                }
            }
        }
    }
`;
